export default __webpack_public_path__ + "static/media/tickWhiteToast.c5b28bc1.svg";